import { useAuth0 } from '@auth0/auth0-react'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import Logo from '../Common/Logo'
import LoginModal from '../Common/LoginModal'

export default function Header() {
  const { isAuthenticated, logout } = useAuth0()
  const [showLogin, setShowLogin] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <header className="bg-white border-b border-gray-100 shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2" onClick={() => setMenuOpen(false)}>
            <Logo size={36} />
            <span className="text-xl font-bold text-primary-700">PetHalo</span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-6">
            {isAuthenticated ? (
              <>
                <Link to="/dashboard" className="text-gray-600 hover:text-primary-500">Dashboard</Link>
                <Link to="/pets" className="text-gray-600 hover:text-primary-500">My Pets</Link>
                <Link to="/privacy" className="text-gray-600 hover:text-primary-500">Privacy</Link>
                <Link to="/profile" className="text-gray-600 hover:text-primary-500">Profile</Link>
                <button
                  onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                  className="text-gray-500 hover:text-primary-500 border border-gray-200 hover:border-primary-300 px-3 py-1.5 rounded-lg transition-colors text-sm"
                >
                  Logout
                </button>
              </>
            ) : (
              <button onClick={() => setShowLogin(true)} className="btn-primary">
                Login
              </button>
            )}
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden p-2 text-gray-600 hover:text-primary-500"
            aria-label="Toggle menu"
          >
            {menuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden mt-3 pt-3 border-t border-gray-100 space-y-2">
            {isAuthenticated ? (
              <>
                <Link to="/dashboard" onClick={() => setMenuOpen(false)} className="block py-2 text-gray-600 hover:text-primary-500">Dashboard</Link>
                <Link to="/pets" onClick={() => setMenuOpen(false)} className="block py-2 text-gray-600 hover:text-primary-500">My Pets</Link>
                <Link to="/privacy" onClick={() => setMenuOpen(false)} className="block py-2 text-gray-600 hover:text-primary-500">Privacy</Link>
                <Link to="/profile" onClick={() => setMenuOpen(false)} className="block py-2 text-gray-600 hover:text-primary-500">Profile</Link>
                <button
                  onClick={() => { setMenuOpen(false); logout({ logoutParams: { returnTo: window.location.origin } }) }}
                  className="block w-full text-left py-2 text-red-500 hover:text-red-700"
                >
                  Logout
                </button>
              </>
            ) : (
              <button
                onClick={() => { setMenuOpen(false); setShowLogin(true) }}
                className="btn-primary w-full"
              >
                Login
              </button>
            )}
          </div>
        )}
      </nav>

      <LoginModal isOpen={showLogin} onClose={() => setShowLogin(false)} />
    </header>
  )
}
